var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4831 3.22236C20.903 -1.07412 27.097 -1.07412 29.5169 3.22236L47.1779 34.5792C49.5513 38.7932 46.5022 44 41.661 44H6.33898C1.49781 44 -1.55133 38.7932 0.822112 34.5792L18.4831 3.22236ZM27.1646 34.518C27.1646 36.2636 25.7476 37.6788 23.9997 37.6788C22.2518 37.6788 20.8348 36.2636 20.8348 34.518C20.8348 32.7723 22.2518 31.3572 23.9997 31.3572C25.7476 31.3572 27.1646 32.7723 27.1646 34.518ZM23.9997 9.23159C22.2518 9.23159 20.8348 10.6467 20.8348 12.3924V21.8748C20.8348 23.6204 22.2518 25.0356 23.9997 25.0356C25.7476 25.0356 27.1646 23.6204 27.1646 21.8748V12.3924C27.1646 10.6467 25.7476 9.23159 23.9997 9.23159Z",
    fill: "#EFA8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.459ef1689a5e2e8072c6a0858e0b92f2.svg";
export { ForwardRef as ReactComponent };